import React, { useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import Piano from '../utils/Piano';
import lang from '../lang.json';
import { useNavigate } from 'react-router-dom';

const Module2 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module2;

    const navigate = useNavigate();

    const [display1, setDisplay1] = useState("none");
    const [display1anim, setDisplay1anim] = useState("none");
    const [display2, setDisplay2] = useState("none");
    const [display2anim, setDisplay2anim] = useState("none");
    const [display3, setDisplay3] = useState("none");
    const [display3anim, setDisplay3anim] = useState("none");
    const [display4, setDisplay4] = useState("none");
    const [display4anim, setDisplay4anim] = useState("none");
    const [display5, setDisplay5] = useState("none");
    const [display5anim, setDisplay5anim] = useState("none");

    const [pause, setPause] = useState(true);

    const [hasStarted, setHasStarted] = useState(false);

    function clearAll() {
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }

        props.audio.forEach(audio => audio.pause());
    }

    const print = (time, paused) => {
        console.log(time, paused);
    }

    const animCallback = (time, paused) => {
        setPause(paused);
        /* page 1 */
        if (!hasStarted && time > 0) {
            setHasStarted(true);
        }
        if (time >= 0 && time < 27) {
            setDisplay1("block");
        } else {
            setDisplay1("none");
        }
        if (time >= 6 && time < 27) {
            setDisplay1anim("block");
        } else {
            setDisplay1anim("none");
        }
        /* page 2 */
        if (time >= 27 && time < 47) {
            setDisplay2("block");
        } else {
            setDisplay2("none");
        }
        if (time >= 36.5 && time < 47) {
            setDisplay2anim("block");
        } else {
            setDisplay2anim("none");
        }
        /* page 3 */
        if (time >= 47 && time < 74) {
            setDisplay3("block");
        } else {
            setDisplay3("none");
        }
        if (time >= 48 && time < 74) {
            setDisplay3anim("block");
        } else {
            setDisplay3anim("none");
        }
        /* page 4 */
        if (time >= 74 && time < 95) {
            setDisplay4("block");
        } else {
            setDisplay4("none");
        }
        if (time >= 75.5 && time < 95) {
            setDisplay4anim("block");
        } else {
            setDisplay4anim("none");
        }
        /* page 5 */
        if (time >= 95 && time < 133) {
            setDisplay5("block");
        } else {
            setDisplay5("none");
        }
        if (time >= 103 && time < 133) {
            setDisplay5anim("block");
        } else {
            setDisplay5anim("none");
        }
    }

    return (
        <>
            <Piano
                dirName={"piano2"}
                numberOfPages={5}
                pageSpeeds={[27.6, 18.9, 27.5, 21, 38,8]} // duree des pages PB9
                musicName={"piano2"}
                callback={animCallback}
                style={{ position: 'absolute', top: '300px' }}
            />
            {/*Page 1*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module2/page1.jpg"}
                alt="page1 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display1 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display1 }}>
                {/*dashed line*/}
                <line x1="165" y1="0" x2="165" y2="443" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <FramePlayer
                dirName="module2_page1"
                ext="jpg"
                frameNumber={4}
                fps={4}
                loop={true}
                paused={pause}
                style={{ position: 'absolute', top: '-20px', left: '168px', display: display1anim }}
            />

            {/*Page 2*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module2/page2.jpg"}
                alt="page2 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display2 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display2 }}>
                {/*dashed line*/}
                <line x1="325" y1="0" x2="325" y2="443" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <FramePlayer
                dirName="module2_page2"
                ext="jpg"
                frameNumber={4}
                fps={4}
                loop={true}
                paused={pause}
                style={{ position: 'absolute', top: '0px', left: '325px', height: '285px', width: '335px', objectFit: 'cover', objectPosition: '0 0', display: display2anim }}
            />

            {/*Page 3*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module2/page3.jpg"}
                alt="page3 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display3 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display3 }}>
                {/*dashed line*/}
                <line x1="45" y1="0" x2="45" y2="443" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <FramePlayer
                dirName="module2_page3"
                ext="jpg"
                frameNumber={4}
                fps={4}
                loop={true}
                paused={pause}
                style={{ position: 'absolute', top: '0px', left: '45px', display: display3anim }}
            />

            {/*Page 4*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module2/page4.jpg"}
                alt="page4 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display4 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display4 }}>
                {/*dashed line*/}
                <line x1="70" y1="0" x2="70" y2="443" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <FramePlayer
                dirName="module2_page4"
                ext="jpg"
                frameNumber={4}
                fps={4}
                loop={true}
                paused={pause}
                style={{ position: 'absolute', top: '0px', left: '70px', display: display4anim }}
            />

            {/*Page 5*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module2/page5.jpg"}
                alt="page5 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display5 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display5 }}>
                {/*dashed line*/}
                <line x1="160" y1="0" x2="160" y2="443" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <FramePlayer
                dirName="module2_page5"
                ext="jpg"
                frameNumber={3}
                fps={4}
                loop={true}
                paused={pause}
                style={{ position: 'absolute', top: '0px', left: '160px', display: display5anim }}
            />

            <img
                src={process.env.PUBLIC_URL + "/assets/images/module2/2.jpg"}
                alt="video"
                style={{
                    position: 'absolute',
                    top: '467px',
                    left: '360px',
                    zIndex: 3,
                    cursor: 'pointer',
                }}
                onClick={() => {
                    clearAll();
                    //window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur'+'/module/2-captation-video/';
                    navigate(process.env.PUBLIC_URL + '/2-captation-video')
                }}
            />

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p style={{
                position: 'absolute',
                left: 10,
                top: 268,
                color: '#3398ff',
                fontSize: '15px',
                zIndex: 15
            }}>{texts.lang33}</p>
            <p style={{
                position: 'absolute',
                right: 8,
                top: 268,
                color: 'red',
                fontSize: '15px',
                zIndex: 15
            }}>{texts.lang34}</p>
            <img
                style={{
                    position: 'absolute',
                    left: 190,
                    top: 4,
                    zIndex: 1,
                    display: hasStarted ? 'none' : 'block'
                }}
                src={process.env.PUBLIC_URL + "/assets/images/module2/bulle.png"}
            />
            <p style={{
                position: 'absolute',
                left: 220,
                top: -4,
                width: 380,
                color: 'white',
                fontSize: '15px',
                zIndex: 1,
                display: hasStarted ? 'none' : 'block'
            }}>{texts.lang30}</p>
            <p style={{
                position: 'absolute',
                left: 220,
                top: 139,
                width: 380,
                color: 'white',
                fontSize: '15px',
                zIndex: 1,
                display: hasStarted ? 'none' : 'block'
            }}>{texts.lang31}</p>
        </>
    );
}

export default Module2;
